(function () {
  /**
   * @ngdoc module
   * @name akitabox.mobile.directives.inputCard
   */
  angular
    .module("akitabox.mobile.directives.inputCard", [])
    .directive("abmInputCard", AbmInputCardDirective);

  /**
   * @ngdoc directive
   * @module akitabox.mobile.directives.inputCard
   * @name AbmInputCardDirective
   *
   * @restrict E
   *
   * @description
   * `<abm-input-card>` is an card with 1..n to nested `<abm-field-container>`. Save and delete functions can be promises.
   *
   * **Note:** `editing` attribute must be the shared between `<abm-input-card>` and nested `<abm-field-container>`
   *
   * @usage
   * <hljs lang="html">
   *   <abm-input-card editing="vm.editing" on-save="vm.onSave()" on-delete="vm.onDelete()">
   *     <md-list-item>
   *       <abm-field-container flex ng-model="vm.description" editing="vm.editing">
   *         <label>Description</label>
   *         <abm-field-placeholder>Enter a description</abm-field-placeholder>
   *         <abm-field-value ng-bind="vm.description"></abm-field-value>
   *         <textarea
   *             rows="7"
   *             ng-model="vm.description"
   *             placeholder="Enter a description"
   *             aria-label="Description">
   *         </textarea>
   *       </abm-field-container>
   *     </md-list-item>
   *   </abm-input-card>
   * </hljs>
   *
   * @ngInject
   */
  function AbmInputCardDirective($timeout) {
    return {
      restrict: "E",
      templateUrl: "app/mobile/directives/input-card/input-card.html",
      replace: true,
      transclude: true,
      controller: AbmInputCardController,
      controllerAs: "vm",
      bindToController: true,
      link: postLink,
      scope: {
        disableSave: "=?",
        editing: "=?",
        onCancel: "&?",
        onSave: "&?",
        onDelete: "&?",
        showButtons: "=?",
        ngDisabled: "&?",
        ngRequired: "&?",
        ngReadonly: "&?",
      },
    };

    function postLink($scope, $element, attrs, vm) {
      // Input element tag names
      var INPUT_TAGS = ["input", "select", "textarea"];

      // Attributes
      vm.disabled = angular.isDefined(attrs.disabled);
      vm.readonly = angular.isDefined(attrs.readonly);
      vm.required = angular.isDefined(attrs.required);
      vm.editable = false;

      // Determine which callbacks the user provided
      vm.hasSave = !angular.isEmpty(attrs.onSave);
      vm.hasDelete = !angular.isEmpty(attrs.onDelete);

      evaluateEditable();

      $timeout(function () {
        vm.loading = false;
        // Find inputs in order to disable during save and delete
        if (vm.hasEdit) {
          for (var i = 0; i < INPUT_TAGS.length; ++i) {
            addInputs(INPUT_TAGS[i]);
          }
        }
      });

      $scope.$watch("vm.ngDisabled()", function (value) {
        if (angular.isDefined(value)) {
          vm.disabled = value;
          evaluateEditable();
        }
      });

      $scope.$watch("vm.ngRequired()", function (value) {
        if (angular.isDefined(value)) {
          vm.required = value;
        }
      });

      $scope.$watch("vm.ngReadonly()", function (value) {
        if (angular.isDefined(value)) {
          vm.readonly = value;
          evaluateEditable();
        }
      });

      /**
       * Add input elements to input list by tag name
       *
       * @param {String} tagName Element tag name
       */
      function addInputs(tagName) {
        angular.forEach($element.find(tagName), function (elem) {
          vm.inputs.push(elem);
        });
      }

      /**
       * Determine if the card is editable. If not, hide button and exit editing mode
       */
      function evaluateEditable() {
        vm.editable =
          !angular.isEmpty(attrs.editing) && !vm.readonly && !vm.disabled;
        vm.showButtons = vm.showButtons && vm.editable;
        if (vm.editing) vm.editing = vm.editable;
      }
    }
  }

  /**
   * @ngdoc controller
   * @module akitabox.mobile.directives.inputCard
   * @name AbmInputCardController
   *
   * @description
   * Controller for the input card directive
   *
   * @ngInject
   */
  function AbmInputCardController($q, $timeout) {
    var self = this;

    // Time (in milliseconds) to wait in order for button ripple animation to commence
    var BUTTON_LAG = 20;

    // Attributes
    self.inputs = [];
    self.editing = angular.isDefined(self.editing) ? self.editing : false;
    self.showButtons = angular.isDefined(self.showButtons)
      ? self.showButtons
      : true;
    self.deleting = false;
    self.saving = false;
    self.hasSave = false;
    self.hasDelete = false;
    self.hasEdit = false;
    self.loading = true;

    // Functions
    self.edit = edit;
    self.save = save;
    self.cancel = cancel;
    self.delete = onDelete;
    self.inEditMode = inEditMode;

    /**
     * Enable input editing
     */
    function edit() {
      self.editing = true;
    }

    /**
     * Disable inputs and invoke save function
     * @return {[type]} [description]
     */
    function save() {
      disableInputs();
      self.saving = true;
      $q.resolve(self.onSave())
        .then(function () {
          self.editing = false;
        })
        .finally(function () {
          self.saving = false;
          enableInputs();
        });
    }

    /**
     * Cancel editing
     */
    function cancel() {
      $timeout(function () {
        self.editing = false;
      }, BUTTON_LAG);

      if (angular.isFunction(self.onCancel)) {
        self.onCancel();
      }
    }

    /**
     * Disable inputs and invoke delete function
     */
    function onDelete() {
      disableInputs();
      self.deleting = true;
      $q.resolve(self.onDelete())
        .then(function () {
          self.editing = false;
          self.deleting = false;
        })
        .finally(function () {
          enableInputs();
        });
    }

    /**
     * Check if card is in edit mode
     *
     * @return {Boolean} True if in edit mode, false if not
     */
    function inEditMode() {
      return self.editing || self.saving;
    }

    /**
     * Disable all nested input elements
     */
    function disableInputs() {
      angular.forEach(self.inputs, function (input) {
        input.setAttribute("disabled", "disabled");
      });
    }

    /**
     * Enable all nested input elements
     */
    function enableInputs() {
      angular.forEach(self.inputs, function (input) {
        input.removeAttribute("disabled");
      });
    }
  }
})();
